import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { IReleaseNotes, ILangItem } from "@common/types/sharedTypes";
import { SXModalBase } from "./SXModal";
import { ReleaseNoteText } from "./ReleaseNoteText";

interface LatestReleaseNotesModalProps {
  close: () => void;
  notes: IReleaseNotes;
  show: boolean;
}

const getNoteText = (note: ILangItem, lang: string) => {
  const key = lang as keyof ILangItem;
  return note[key] ?? note.en;
};

export const LatestReleaseNotesModal = ({ close, notes, show }: LatestReleaseNotesModalProps) => {
  const { t, i18n } = useTranslation();
  const latestRelease = notes?.releases?.[0];

  if (!latestRelease) {
    return null;
  }

  return (
    <SXModalBase
      header={t("news_in_latest_version")}
      show={show}
      size="lg"
      close={close}
      body={
        <>
          <strong>
            {latestRelease.version} ({latestRelease.date})
          </strong>
          <ul>
            {latestRelease.notes.map((note, index) => (
              <li key={`${latestRelease.version}-${index}`}>
                <ReleaseNoteText text={getNoteText(note, i18n.language)} />
              </li>
            ))}
          </ul>
        </>
      }
      footer={
        <Button id="releaseNotesOk" className="modal-btn" onClick={close}>
          {t("buttons.close")}
        </Button>
      }
    />
  );
};
